import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_pusher_event.js";
//#region src/bite_log_pusher_event_helper.ts
var bite_log_pusher_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "connected";
		case 2: return "subscribed";
		case 3: return "disconnected";
		case 4: return "failed-to-connect";
		case 5: return "failed-to-subscribe";
		case 6: return "error";
		case 7: return "initialized";
	}
}
//#endregion
export { bite_log_pusher_event_helper_exports, name };

//# sourceMappingURL=bite_log_pusher_event_helper.js.map